export const SALE_TIME_CHART = 'saleTimeChart';
